import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useResizeObserver } from '@react-hookz/web';
import { Fragment, useRef } from 'react';
import { Container } from '../../primitives/SegmentedList/components/Container.js';
import { Divider } from '../../primitives/SegmentedList/components/Divider.js';
import { ListItem } from '../../primitives/SegmentedList/components/ListItem.js';
const HIDE = 'none';
const SHOW = 'inline-block';
export const SegmentedList = ({
  alignment = 'left',
  items,
  rowSpacing = 'lists/small',
  columnSpacing = 'lists/medium',
  ...dividerProps
}) => {
  const ref = useRef(null);
  useResizeObserver(ref, entry => {
    entry.target.childNodes
    // eslint-disable-next-line unicorn/no-array-for-each -- forEach is just easier to read in this case
    .forEach((element, index, listOfChildren) => {
      const previousElement = listOfChildren[index - 1];
      if (index === 0 || !(element instanceof HTMLElement && previousElement instanceof HTMLElement)) {
        return;
      }
      // if element is more to the left than it's previous element it means it wrapped to a new line
      const isWrapping = element.offsetTop > previousElement.offsetTop;
      if (element instanceof HTMLLIElement) {
        if (alignment === 'left') {
          previousElement.style.borderColor = isWrapping ? 'transparent' : '';
          if (element.nextElementSibling instanceof HTMLElement) {
            element.nextElementSibling.style.display = SHOW;
          }
        } else {
          previousElement.style.display = isWrapping ? HIDE : SHOW;
        }
      } else {
        element.style.display = isWrapping ? HIDE : SHOW;
      }
    });
  }, true);
  return _jsx(Container, {
    as: "ul",
    // @ts-expect-error ...
    ref: ref,
    columnGap: columnSpacing,
    rowGap: rowSpacing,
    justifyContent: alignment === 'right' ? 'flex-end' : 'flex-start',
    children: items.map((item, index) => _jsxs(Fragment, {
      children: [_jsx(ListItem, {
        style: {
          textAlign: alignment
        },
        children: item
      }), index !== items.length - 1 && _jsx(Divider, {
        "aria-hidden": "true",
        orientation: "vertical",
        ...dividerProps
      })]
    }, index))
  });
};